import { Float32BufferAttribute } from 'three';

import {
  CesiumPnts,
  getFeatureElementSize,
  PntsFeatureTable,
} from '../../../../../loader/cesium/content/pnts/types';
import { BufferAttributeAdapter } from './buffer-attribute-adapter';

export const ClassificationBufferAttribute: BufferAttributeAdapter = (
  feature: keyof PntsFeatureTable,
  pntsData: CesiumPnts,
) => {
  const buffer = pntsData.features.batchBody;
  const offset = pntsData.features.batchTable?.Classification?.byteOffset;
  const pointsCount = pntsData.features.featureTable.POINTS_LENGTH;

  if (buffer === undefined || offset === undefined) {
    // If no classification exist, set unclassified for all points.
    return new Float32BufferAttribute(
      new Uint8Array(pointsCount * getFeatureElementSize(feature)).map((i) => (i = 1)),
      getFeatureElementSize(feature),
      true,
    );
  }

  return new Float32BufferAttribute(
    new Uint8Array(buffer, offset, pointsCount),
    getFeatureElementSize(feature),
    true,
  );
};
